export class UserNotAuthenticatedError extends Error {
	constructor() {
		super(
			"User not authenticated this component can only be used within an authenticated component.",
		);
	}
}
